module.exports = new __parcel__URL__("light-comments-empty.213e59fa.svg").toString();